<template>
  <div>
    <div v-if="isLoading" :style="loadingStyles">
      <BaseSpinner />
    </div>
    <b-row v-else class="justify-content-center">
      <b-col class="col-md-6" v-if="step === 1">
        <div class="payment">
          <div class="container">
            <div class="payment__group" :class="paymentGroupOneColClass">
              <div class="payment__card">
                <div v-if="!isPublicInstitution">
                  <h2 class="payment__title">Como deseja pagar?</h2>
                  <ul class="payment__custom-radio">
                    <li
                      class="payment__custom-radio-list-item"
                      v-for="(payment_method, index) in payment_methods"
                      :key="index"
                    >
                      <input
                        type="radio"
                        :id="'radio' + index"
                        name="radio"
                        :value="payment_method.value"
                        v-model="selectedPaymentMethod"
                        class="payment__custom-radio-item"
                      />
                      <label :for="'radio' + index">
                        <span class="payment__card-choice">
                          {{ payment_method.label }}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div v-if="!isPublicInstitution" class="payment__health-plan">
                  <h2 class="payment__title">Selecione o seu convênio</h2>
                  <div class="custom-form-control">
                    <label>
                      Convênio
                      <span :class="{ disabled: !hasInsuranceEnrollments }">
                        {{ insuranceEnrollmentLabelText }}
                      </span>
                    </label>
                    <select
                      class="custom-select form-control"
                      :disabled="!hasInsuranceEnrollments"
                      @change="onSetInsuranceEnrollment"
                    >
                      <option value="null" disabled selected>
                        Selecione um convênio
                      </option>
                      <option
                        v-for="insurance_enrollment in currentUser.insurance_enrollments"
                        :key="insurance_enrollment.id"
                        :value="insurance_enrollment.id"
                      >
                        {{ insurance_enrollment.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="payment__reason">
                  <h2 class="payment__title">Motivo da consulta? (opcional)</h2>
                  <textarea
                    :style="textarea_style"
                    class="form-control"
                    :id="'radio'"
                    placeholder="Gostaria de fazer um resumo para o profissional de saúde sobre a motivação da sua consulta?"
                    rows="6"
                    v-model="observation"
                  />
                </div>
                <div v-if="!isPublicInstitution" class="payment__button">
                  <button
                    class="button3"
                    @click.prevent="step++"
                    :disabled="!selectedPaymentMethod"
                  >
                    Prosseguir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col
        class="col-md-6"
        v-if="step === 2 && selectedPaymentMethod == 'credit_card'"
      >
        <div class="payment">
          <div class="container">
            <div class="payment__group">
              <div class="payment__card">
                <h2 class="payment__title">Como deseja pagar?</h2>
                <ul class="payment__custom-radio">
                  <li
                    class="payment__custom-radio-list-item"
                    v-for="(credit_card, index) in creditCards"
                    :key="index"
                  >
                    <input
                      type="radio"
                      :id="'radio' + index"
                      name="radio"
                      :value="credit_card"
                      v-model="selectedCreditCard"
                      class="payment__custom-radio-item"
                    />
                    <label :for="'radio' + index">
                      <span class="payment__card-choice">
                        {{ credit_card.nickname }}
                      </span>
                      <span class="payment__number">
                        {{ credit_card.last_four }}
                      </span>
                    </label>
                  </li>
                  <li
                    class="payment__custom-radio-list-item"
                    @click.prevent="addCreditCard()"
                  >
                    <input
                      type="radio"
                      id="radio02"
                      name="radio"
                      value="2"
                      class="payment__custom-radio-item"
                    />
                    <label for="radio02">
                      <span class="card-add">Adicione um cartão</span>
                    </label>
                  </li>
                </ul>
                <!-- Botão para prosseguir com o pagamento -->
                <div
                  class="payment__button"
                  style="justify-content: space-between;"
                >
                  <button
                    class="button3"
                    @click.prevent="
                      step--;
                      selectedPaymentMethod = '';
                    "
                  >
                    Voltar
                  </button>
                  <button
                    class="button3"
                    @click.prevent="validatePaymentMethod()"
                    :disabled="!canPaymentMethod"
                  >
                    Prosseguir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="col-md-6">
        <CardScheduleConsult
          :selected-insurance-enrollment="selectedInsuranceEnrollment"
          :selected-credit-card="selectedCreditCard"
          :selected-payment-method="selectedPaymentMethod"
          :is-public-institution="isPublicInstitution"
          :step="step"
          :observation="observation"
          @changeCreditCard="changeCreditCard"
        />
      </b-col>
    </b-row>
    <b-modal
      id="createCreditCard"
      ref="createCreditCard"
      size="lg"
      centered
      hide-footer
    >
      <div class="profile" :style="profileInlineStyles">
        <CreditCard
          @pushNewCreditCard="pushNewCreditCard"
          :style="profileCardInlineStyles"
        />
      </div>
    </b-modal>

    <b-modal
      id="updateAddress"
      ref="updateAddress"
      size="lg"
      centered
      hide-footer
    >
      <div class="profile" :style="profileInlineStyles">
        <AddressForm
          @addressCreated="addressCreated"
          :style="profileCardInlineStyles"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardScheduleConsult from "../components/CardScheduleConsult";
import CreditCard from "../components/CreditCard";
// import Address from "../components/Address";
import AddressForm from "../components/AddressForm.vue";
import BaseSpinner from "../components/base/BaseSpinner.vue";
import { userMethods, userComputed } from "./../state/helpers";

export default {
  name: "ScheduleSCreen",
  components: {
    CardScheduleConsult,
    CreditCard,
    // Address,
    AddressForm,
    BaseSpinner
  },
  data() {
    return {
      error: null,
      isLoading: false,
      step: 1,
      selectedPaymentMethod: "",
      selectedCreditCard: {},
      selectedInsuranceEnrollment: {},
      creditCards: [],
      observation: "",
      payment_methods: [
        { label: "Cartão de crédito", value: "credit_card" },
        { label: "Pix", value: "pix" }
      ]
    };
  },
  async mounted() {
    await this.fetchUserCreditCards().then(response => {
      this.creditCards = response.data;
    });
    await this.getUserInsuranceEnrollments();
  },
  methods: {
    ...userMethods,
    validatePaymentMethod() {
      this.step++;
    },
    addCreditCard() {
      if (!this.currentUser.address || !this.currentUser.address.id)
        return this.$bvModal.show("updateAddress");

      return this.$bvModal.show("createCreditCard");
    },
    async getUserInsuranceEnrollments() {
      try {
        this.isLoading = true;
        await this.fetchInsuranceEnrollments(this.currentSchedule.doctor.id);
      } catch (err) {
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
    onSetInsuranceEnrollment($event) {
      let selected = this.currentUser.insurance_enrollments.find(
        enrollment => enrollment.id == $event.target.value
      );
      this.selectedInsuranceEnrollment = selected;
    },
    changeCreditCard() {
      this.step = 1;
      this.selectedPaymentMethod = "";
      this.selectedCreditCard = {};
    },
    pushNewCreditCard(credit_card) {
      this.selectedCreditCard = credit_card;
      this.$bvModal.hide("createCreditCard");
    },
    addressCreated() {
      this.$bvModal.hide("updateAddress");
      this.$bvModal.show("createCreditCard");
    }
  },
  computed: {
    ...userComputed,
    currentSchedule() {
      return this.$store.state.appointments.currentSchedule;
    },
    insuranceEnrollmentLabelText() {
      let insuranceEnrollments = this.currentUser.insurance_enrollments;
      if (insuranceEnrollments.length >= 1) {
        return `${insuranceEnrollments.length} disponível para uso`;
      } else if (insuranceEnrollments.length > 1) {
        return `${insuranceEnrollments.length} disponíveis para uso`;
      }
      return "Nenhum disponível";
    },
    hasInsuranceEnrollments() {
      return this.currentUser.insurance_enrollments.length;
    },
    canPaymentMethod() {
      return !!this.selectedCreditCard.id;
    },
    isPublicInstitution() {
      return (
        this.currentSchedule.institution_type &&
        this.currentSchedule.institution_type === "public_institutions"
      );
    },
    profileInlineStyles() {
      return `
        min-height: 100%;
        padding: 0;
        margin: 0;
      `;
    },
    profileCardInlineStyles() {
      return `
        margin: 0;
        box-shadow: none;
      `;
    },
    textarea_style() {
      return `
        margin-top: 2rem;
        padding: 10px;
        width: 100%;
        border-radius: 15px;
      `;
    },
    loadingStyles() {
      return `
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20rem 4rem;
      `;
    },
    paymentGroupOneColClass() {
      return this.isPublicInstitution ? "payment__group--one-col" : "";
    }
  }
};
</script>
